import React from 'react';
import { AppRouter } from './AppRouter';
import { AuthProvider } from './contexts/AuthContext';
export function App() {
  return <AuthProvider data-id="element-0">
      <AppRouter data-id="element-1" />
    </AuthProvider>;
}